import BaseResource from './BaseResource';
import { CharacterData } from './CharacterResource';
export interface ParticipantData {
  id: string;
  name: string;
  role: string;
  description?: string;
  avatar?: string;
  character?: CharacterData;
}

class ParticipantResource extends BaseResource<ParticipantData> {
  static get storeName(): string {
    return 'ParticipantResource';
  }

  static get endpoint(): string {
    return `/coach/participants`;
  }

  static toObject(raw: any): ParticipantResource {
    return new ParticipantResource(raw as ParticipantData);
  }
}

export default ParticipantResource;
